/**
 * Created by AlexanderC on 6/10/15.
 */

/*eslint max-len: 0*/

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidDeepIdentifierException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when trying to parse an invalid deep identifier
 */
let InvalidDeepIdentifierException = exports.InvalidDeepIdentifierException = function (_Exception) {
  _inherits(InvalidDeepIdentifierException, _Exception);

  /**
   * @param {String} identifier
   */
  function InvalidDeepIdentifierException(identifier) {
    _classCallCheck(this, InvalidDeepIdentifierException);

    return _possibleConstructorReturn(this, (InvalidDeepIdentifierException.__proto__ || Object.getPrototypeOf(InvalidDeepIdentifierException)).call(this, `Invalid deep identifier "${identifier}". It should conform to the following format: @microservice_identifier:resource_identifier.`));
  }

  return InvalidDeepIdentifierException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Exception/InvalidDeepIdentifierException.js
// module id = 393
// module chunks = 0